import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { ReCaptcha } from "./Recaptcha";
import useStyles from "./styles/StartChatForm.styles";
import { Button, Link } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { isPossiblePhoneNumber } from "libphonenumber-js";
import { isValidPhoneNumber } from "libphonenumber-js/core";
import { matches } from "validator";

/**
 * Start new chat after submitting contact information.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function StartChatForm(props) {
  const classes = useStyles();

  const [name, setName] = useState("");
  const [validationEmail, setValidationEmail] = useState("");
  const [validationPhone, setValidationPhone] = useState("");
  const [token, setToken] = useState("");

  const { handleSubmit, register, errors, setValue } = useForm({
    mode: "onChange",
  });

  const onSubmit = (values) => {
    if(props.isClientAvailable === true) {
      props.onStartChatFormSubmit(values);
    }else if(props.isClientAvailable === false) {
      props.onStartChatFormSubmitClientUnavailable(values);
    }

    setToken("");
  };

  const handleValidationEmailChange = (event) => {
    setValidationEmail(event.target.value);
  };
  const handleValidationPhoneChange = (event) => {
    setValidationPhone(event.target.value);
  };
  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const onVerifyCaptcha = (token) => {
    setValue("captchaToken", token);
  };

  useEffect(() => {
    register({ name: "captchaToken" }, { required: true });
  });

  return (
    <div className={classes.startChatForm}>
      <p>Fill out the form to start chatting!</p>
      <ValidatorForm onSubmit={handleSubmit(onSubmit)}>
        <TextValidator
          inputProps={{ name: "name", maxLength: 70 }}
          inputRef={register}
          onChange={handleNameChange}
          label="Name"
          value={name}
          id="outlined-basic"
          name="name"
          fullWidth={true}
          className={classes.chatFormInput}
          variant="outlined"
          validators={["required"]}
          errorMessages={["Please enter your name."]}
          aria-invalid={errors.name ? "true" : "false"}
        />
        { props.validationEmail ?
        <TextValidator
          inputRef={register}
          onChange={handleValidationEmailChange}
          label="Email"
          value={validationEmail}
          id="validationEmail"
          name="validationEmail"
          fullWidth={true}
          className={classes.chatFormInput}
          variant="outlined"
          validators={["required", "isEmail"]}
          errorMessages={[
            "Please enter your email address.",
            "Email is not valid.",
          ]}
          aria-invalid={errors.validationEmail ? "true" : "false"}
        />
        : ""}
        { props.validationPhone ?
        <TextValidator
          inputRef={register}
          onChange={handleValidationPhoneChange}
          label="Phone Number"
          value={validationPhone}
          id="validationPhone"
          name="validationPhone"
          fullWidth={true}
          className={classes.chatFormInput}
          variant="outlined"
          validators={["required", 'matchRegexp:^(\\+\\d{1,2}\\s?)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$']}
          errorMessages={[
            "Please enter your phone number.",
            "Phone is not valid.",
          ]}
          aria-invalid={errors.validationPhone ? "true" : "false"}
        />
        : ""}
        <ReCaptcha
          token={token}
          setToken={setToken}
          onVerifyCaptcha={onVerifyCaptcha}
        />

        <Button
          disabled={props.isSubmitting || token === ""}
          type="submit"
          size="large"
          fullWidth={true}
          variant="contained"
          color="primary"
        >
          {props.isSubmitting ? "Loading.." : "Start Chat"}
        </Button>
        {props.formError && (
          <Alert severity="error" style={{ width: "100%", marginTop: "10px" }}>
            {props.formError}
          </Alert>
        )}
        <p className={classes.recaptchaText}>
          This site is protected by reCAPTCHA and the Google
          <Link href="https://policies.google.com/privacy" target="_blank">
            &nbsp;Privacy Policy&nbsp;
          </Link>
          and
          <Link href="https://policies.google.com/terms" target="_blank">
            &nbsp;Terms of Service&nbsp;
          </Link>
          apply.
        </p>
      </ValidatorForm>
    </div>
  );
}

export default StartChatForm;
